import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;
const environment =
  process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "preview";

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: environment === "production" ? 0.2 : 1.0,
    sendDefaultPii: false,
  });
}
